import type { HouseAdCampaign } from "./types.js";

/** 광고 클릭 이동 대상을 가르는 플랫폼 — 앱이 문자열로 주입(패키지는 Capacitor 비의존, DIP). */
export type AdPlatform = "ios" | "android" | "web";

/**
 * 캠페인 클릭(CTA) 시 이동할 URL을 플랫폼별로 선택한다 (순수).
 * iOS 기기는 App Store(`clickUrlIos`), Android는 Play Store(`clickUrlAndroid`)로 보내되,
 * 해당 override가 비어 있으면(미지정/빈 문자열) 기본 `clickUrl`로 폴백한다.
 * 웹은 항상 `clickUrl`.
 */
export function resolveClickUrl(campaign: HouseAdCampaign, platform: AdPlatform): string {
  if (platform === "ios" && campaign.clickUrlIos) return campaign.clickUrlIos;
  if (platform === "android" && campaign.clickUrlAndroid) return campaign.clickUrlAndroid;
  return campaign.clickUrl;
}
